import React, {useContext} from 'react';
import * as R from 'ramda';
import AmoebaLink from '@/components/AmoebaLink';
import Icon from '@/views/shared/Icon';
import {
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';

import styles from '@/views/Layout/internal/InternalNavBar/index.module.css';
import {userCtx} from '@/auth';
import {maybe} from '@/util';

const iconList = [
  {name: 'service', icon: 'th-large'},
  {name: 'batch', icon: 'tasks'},
  {name: 'commission', icon: 'star'},
  {name: 'subsystem', icon: 'star'},
  {name: 'report', icon: 'print'},
  {name: 'user', icon: 'users'},
  {name: 'newsLetter', icon: 'envelope'},
  {name: 'settings', icon: 'wrench'},
  {name: 'chart', icon: 'chart-bar'},
  {name: 'valuation', icon: 'tachometer-alt'},
  {name: 'datafeed', icon: 'exchange-alt'},
  {name: 'bvFactor', icon: 'table'},
  {name: 'sync', icon: 'exchange-alt'},
];

const useDetectMenu = (name, type) => {
  const user = useContext(userCtx);

  const x = R.propEq('type', type);
  const y = R.propEq('name', name);

  const menu = R.find(R.allPass([x, y]))(user.currentStaff.menu);
  const icon = R.find(R.propEq('name', name))(iconList);

  if (!menu) {
    return null;
  }

  return R.merge(menu, icon);
};

const MainMenuFor = ({name, style, label, children}) => {
  const mainMenu = useDetectMenu(name, 'mainMenu');

  const defaultLayout = menu => (
    <NavItem key='mainMenuFor' className={`nav-link ${styles.nav_link}`}>
      <AmoebaLink href={menu.path} style={style}>
        <Icon icon={menu.icon} /> {label}
      </AmoebaLink>
    </NavItem>
  );

  const mainLayout = menu =>
    maybe(children)
      .map(() => children)
      .orElse(defaultLayout(menu));

  return maybe(mainMenu).map(menu => mainLayout(menu));
};

const MenuFor = ({name, style, label}) => {
  const subMenu = useDetectMenu(name, 'subMenu');

  return (
    <>
      {maybe(subMenu).map(menu => (
        <AmoebaLink key='menuFor' href={menu.path} style={style}>
          {label}
        </AmoebaLink>
      ))}
    </>
  );
};

const LabelFor = ({name, label}) => {
  const labelMenu = useDetectMenu(name, 'label');

  return (
    <>
      {maybe(labelMenu).map(() => (
        <h3 key='labelFor'>{label}</h3>
      ))}
    </>
  );
};

const DropdownMainMenu = ({name, label, children}) => {
  const icon = R.find(R.propEq('name', name))(iconList);

  return (
    <UncontrolledDropdown nav inNavbar className={styles.dropdown_toggle}>
      <DropdownToggle nav className={styles.nav_link}>
        <Icon icon={icon.icon} /> {label}
      </DropdownToggle>
      <DropdownMenu className={`p-2 text-muted ${styles.dropdown_menu_area}`}>
        {children}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export {MainMenuFor, MenuFor, LabelFor, DropdownMainMenu};
